import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReservationAlertsDialogComponent } from './reservation-alerts-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';

@NgModule({
    declarations: [ReservationAlertsDialogComponent],
    imports: [CommonModule, MatDialogModule, MatListModule, MatIconModule, MatDividerModule, MatButtonModule],
    exports: [ReservationAlertsDialogComponent]
})
export class ReservationAlertsDialogModule {}
